<template>
  <div class="min-h-screen bg-white">
    <Header />
    <main>
      <HeroSection />
      <HowItWorks />
      <AiAssistant />
      <ConsultationTypes />
      <!-- TODO: Add VetTeam section once we have real vets on board -->
      <FaqSection />
      <FinalCta />
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Header from '#components/base/Header.vue';
import HeroSection from '#components/vet/HeroSection.vue';
import HowItWorks from '#components/vet/HowItWorks.vue';
import AiAssistant from '#components/vet/AiAssistant.vue';
import ConsultationTypes from '#components/vet/ConsultationTypes.vue';
import FaqSection from '#components/vet/FaqSection.vue';
import FinalCta from '#components/vet/FinalCta.vue';
import Footer from '#components/base/Footer.vue';
import { computed } from 'vue';
import { useSchemaOrg, useSeoMeta, defineWebPage, useI18n, useRuntimeConfig, useRoute, useHead } from '#imports';
import { useBreadcrumbSchema } from '#composables/useBreadcrumbSchema';

definePageMeta({ layout: false });

const { $ts } = useI18n();
const { public: { siteUrl } } = useRuntimeConfig();
const route = useRoute();

const canonicalUrl = computed(() => `${siteUrl}${route.path}`);

useSeoMeta({
  title: () => $ts('seo.title'),
  description: () => $ts('seo.description'),
  ogTitle: () => $ts('seo.title'),
  ogDescription: () => $ts('seo.description'),
  ogType: 'website',
  ogUrl: () => canonicalUrl.value,
});

useHead({
  link: [{ rel: 'canonical', href: () => canonicalUrl.value }],
});

useSchemaOrg([
  defineWebPage({ '@type': 'WebPage' }),
]);

useBreadcrumbSchema([
  { name: 'Home', item: '/' },
  { name: 'Online Vet' },
]);
</script>
